import React, { Component}  from 'react';
import fb from './../assets/fb.png'
import ig from './../assets/ig.png'
import fbw from './../assets/fbw.png'
import igw from './../assets/igw.png'

export const Social = ((props) => {
    var FB  = (props.modal === true) ? fbw : fb
    var IG  = (props.modal === true) ? igw : ig
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
       var hrefig = "https://www.instagram.com/cosmic_moons/"
       if(/Android/i.test(navigator.userAgent)){
        var hreffb = "fb://facewebmodal/f?href=https://www.facebook.com/cosmicmoonss/"
       } else {
        var hreffb = "fb://page/407173389807958"
       }
    } else {
        var hrefig = "https://www.instagram.com/cosmic_moons/"
        var hreffb = "https://www.facebook.com/cosmicmoonss/"
    }
    return(
    <div style={{ zIndex:2,display:'flex',justifyContent:'space-around',marginBottom: 0, justifySelf: 'center' }}>
                        <a href={hreffb} target="_blank"><img style={{width:'20px',marginRight:'50px'}} src={FB}/></a>
                        <a href={hrefig} target="_blank"><img style={{width:'20px'}} src={IG}/></a>
        </div>
    )
})        



// WEBPACK FOOTER //
// ./src/components/Social.js